// src/components/games/edit/GameEditPurchaseBox.js
import React, { useRef, useState, useEffect } from 'react';
import { FaShoppingBag, FaHeart, FaPlus } from 'react-icons/fa';

export default function GameEditPurchaseBox({
  gameName = '',
  price = '',
  discountRate = '',
  comingSoon = false,
  backgroundImage = '',
  link = '',
  onLinkChange = () => {},
  onPriceChange = () => {},
  onDiscountChange = () => {},
  onBackgroundChange = () => {},
}) {
  const bgInputRef = useRef();
  const [bgUrl, setBgUrl] = useState(backgroundImage);

  useEffect(() => {
    setBgUrl(backgroundImage);
  }, [backgroundImage]);

  const handleAddMedia = e => {
    e.stopPropagation();
    bgInputRef.current?.click();
  };
  const handleBgChange = e => {
    const file = e.target.files?.[0];
    if (file) {
      setBgUrl(URL.createObjectURL(file));
      onBackgroundChange(file);
    }
    e.target.value = null;
  };
  const handlePriceChange = e => {
    const digits = e.target.value.replace(/\D/g, '').slice(0, 7);
    onPriceChange(digits);
  };
  const handleDiscountChange = e => {
    let num = e.target.value.replace(/\D/g, '').slice(0, 3);
    num = Math.min(Math.max(Number(num) || 0, 0), 100);
    onDiscountChange(String(num));
  };
  const handleLinkChange = e => {
    onLinkChange(e.target.value);
  };

  const numericPrice = Number(price) || 0;
  const numericDiscount = Number(discountRate) || 0;
  const discountedPrice = Math.round(numericPrice * (100 - numericDiscount) / 100);

  let priceInfo;
  if (numericPrice === 0 && numericDiscount === 0) {
    priceInfo = comingSoon
      ? <span className="text-yellow-300 text-2xl font-bold">출시예정</span>
      : <span className="text-green-400 text-2xl font-bold">무료</span>;
  } else {
    priceInfo = (
      <div className="flex items-center space-x-2">
        {numericDiscount > 0 && (
          <>
            <span className="text-red-400 text-sm font-bold">-{numericDiscount}%</span>
            <span className="line-through text-2xl text-gray-500">
              ₩{numericPrice.toLocaleString()}
            </span>
          </>
        )}
        <span className="text-white text-2xl font-bold">
          ₩{discountedPrice.toLocaleString()}
        </span>
      </div>
    );
  }

  return (
    <div
      className="relative w-full bg-cover bg-center rounded overflow-hidden"
      style={{ minHeight: '240px', backgroundImage: `url('${bgUrl}')` }}
    >
      <input
        type="file"
        accept="image/*"
        ref={bgInputRef}
        onChange={handleBgChange}
        className="hidden"
      />
      <button
        type="button"
        onClick={handleAddMedia}
        className="absolute top-4 left-4 z-10 flex items-center px-3 py-1 bg-blue-600 hover:bg-blue-500 rounded text-white text-sm"
      >
        <FaPlus className="mr-1" /> 미디어 추가
      </button>

      <input
        type="text"
        value={link}
        onChange={handleLinkChange}
        placeholder="링크 입력"
        className="absolute top-4 right-4 z-10 w-52 p-2 bg-[#121212] border border-gray-600 rounded text-xs text-gray-200"
      />

      <div className="absolute inset-0 bg-gradient-to-t from-neutral-800 to-transparent" />

      <div className="absolute inset-x-0 bottom-0 px-6 pb-4 flex flex-col space-y-2">
        <div className="flex items-center pb-4">
          <p className="text-white text-2xl font-bold">{gameName}</p>
          <span className="ml-2 text-white text-2xl font-bold">구매</span>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="flex items-center bg-[#121212] border border-gray-600 rounded px-2 py-1">
              <input
                type="text"
                value={discountRate}
                onChange={handleDiscountChange}
                placeholder="%"
                className="w-8 bg-transparent focus:outline-none text-red-400 font-bold text-center"
                inputMode="numeric"
                pattern="\d*"
                maxLength={3}
              />
              <span className="ml-1 text-red-400 font-bold">%</span>
            </div>
            <div className="flex items-center bg-[#121212] border border-gray-600 rounded px-2 py-1">
              <span className="px-1">₩</span>
              <input
                type="text"
                value={price}
                onChange={handlePriceChange}
                placeholder="가격"
                className="w-16 bg-transparent focus:outline-none text-white text-center"
                inputMode="numeric"
                pattern="\d*"
                maxLength={7}
              />
            </div>
          </div>

          <div className="flex items-center space-x-4">
            {priceInfo}

            <button
              type="button"
              className="bg-orange-500 hover:bg-orange-600 text-white px-3 py-2 rounded flex items-center gap-2 whitespace-nowrap"
            >
              <FaShoppingBag /> 담기
            </button>
            <button
              type="button"
              className="p-3 rounded bg-neutral-700 hover:bg-neutral-600 text-white"
            >
              <FaHeart className="text-white/70" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
